(function() {
  'use strict';

  angular.module('clientDashboardApp.admin.adminSearch', ['clientDashboardApp.admin.adminSearch.adminSearchService']).directive('adminSearch', adminSearch);

  AdminSearchController.$inject = ['$scope','adminSearchService', 'pagingService'];

  function AdminSearchController($scope, adminSearchService, pagingService){
    var vm = this;

    $scope.searchQuery = adminSearchService.getSearchQuery();
    vm.updateSearchQuery = function(){
      adminSearchService.setSearchQuery($scope.searchQuery);
    }

    $scope.submitTasks = function(){
      pagingService.resetPagingState();
      $scope.refresh();
    }

  }

  function adminSearch(){
    var template = `
    <form ng-submit="submitTasks()">
      <div class="input-group">
        <input class="form-control form-control-constrained-width" id="userSearchQuery" ng-change="vm.updateSearchQuery()" ng-model="searchQuery" type="text" placeholder="Search {{pageType}}">
        <div class="input-group-append">
          <button class="btn btn-secondary d-flex align-items-center" type="submit">
            <i class="far fa-search"></i>
          </button>
        </div>
      </div>
    </form>`;
    return {
      template: template,
      restrict: 'A',
      scope: {
        refresh: '&',
        pageType: '@',
        searchQuery: '='
      },
      controller: AdminSearchController,
      controllerAs: 'vm'
    }
  }


})();
